var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSignout = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16.003.002a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4h-12a4 4 0 0 1-4-4v-4.61h9.643L8.02 13.02a1.38 1.38 0 0 0-.408.983c0 .371.145.72.408.983.262.263.612.408.983.408s.72-.145.983-.408l4.01-4.008c.255-.261.397-.606.398-.971v-.008a1.39 1.39 0 0 0-.4-.972L9.986 5.02a1.38 1.38 0 0 0-.983-.408 1.393 1.393 0 0 0-.983 2.374l1.626 1.626H.003v-4.61a4 4 0 0 1 4-3.999z"
})));
export default SvgSignout;